import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { HitlRequest } from "@/api/types";

const KEY = ["hitl-requests"] as const;

export function useHitlRequests() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.GET<HitlRequest[]>("/hitl-requests"),
    refetchInterval: 30_000,
  });
}

export function useHitlRequest(hitlId: string) {
  return useQuery({
    queryKey: [...KEY, hitlId],
    queryFn: () => api.GET<HitlRequest>(`/hitl-requests/${hitlId}`),
    enabled: Boolean(hitlId),
  });
}

// ``useDecideHitl`` foi removido: o endpoint /decide retorna SSE, nao
// JSON, entao um ``api.POST`` fica pendurado esperando o body fechar.
// Use ``openSseStream`` direto (ver ChatStream.decideHitl).
